import React, { useEffect, useState, useRef } from "react";
import { Marker } from "@react-google-maps/api";
import { createMarkerIcon } from "./MapaMultipleStaticMarkers";
import { startSocketConnection } from "../../../../SocketProvider";

export default function DynamicMarkers({ icon, cab, id }) {
  const markerIcon = createMarkerIcon("farmacia", icon);
  const [position, setPosition] = useState({
    lat: -32.9650072,
    lng: -60.6372113,
  });
  const [markers, setMarkers] = useState(cab.mapa_markers_dinamicos || []);
  const socket = useRef(null);

  useEffect(() => {
    if (!socket.current) {
      socket.current = startSocketConnection({
        id_a: cab.id_a,
        id: Number(id),
      });
      return;
    }
    const socketIo = socket.current;

    socketIo.on("coordenadas_actualizadas", (data) => {
      console.log("Recibido:", data);
      // actualizar tus marcadores
      setMarkers(data);
    });

    return () => {
      socketIo.off("coordenadas_actualizadas");
    };
  }, [cab.id_a, id, socket]);

  return (
    <>
      {markers?.length > 0 ? (
        markers.map((m) => (
          <Marker
            key="dynamic-marker"
            position={{
              lat: m.lat || position.lat,
              lng: m.lng || position.lng,
            }}
            icon={markerIcon}
          />
        ))
      ) : (
        <></>
      )}
    </>
  );
}
